/* tslint:disable */

/**
 */
export class PaymentForm {
    from_date?: string;
    to_date?: string;
    type_payment?: string;
}
